<div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent select">
    <span>{{ customFieldForm.value.name }}</span>
    <mat-form-field class="role-field">
        <mat-label>{{ customFieldForm.value.placeholder }}</mat-label>
        <mat-select fxFlex="1 1 100%" [formControl]="customFieldForm.get('value') | cast">
            <mat-option *ngFor="let option of customFieldForm.value.options" [value]="option">{{ option }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
